<template>
  <b-container id="layout-about" class="py-4">
    <b-row>
      <b-col>
        <div class="sub-header-text mb-3" v-if="aboutUs.title">
          {{ aboutUs.title }}
          <b-button
            variant="ghost"
            class="text-muted"
            :style="{ color: webDesign && webDesign.design.main_color ? `${webDesign.design.main_color} !important` : null }"
            @click="$bvModal.show('about-us-more-info')">
            More Info
          </b-button>
        </div>
        <div v-if="aboutUs.description" v-html="aboutUs.description"></div>
      </b-col>
      <b-col v-if="aboutUs.use_image && aboutUs.image" cols="12" md="6" class="mt-3 mt-lg-0">
        <b-img :src="aboutUs.image" fluid alt="About Us" /> 
      </b-col>
    </b-row>
    <MoreInfoModal :content="aboutUs" />
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MoreInfoModal from './MoreInfoModal';
export default {
  components: { MoreInfoModal },
  computed: {
    ...mapGetters('design', ['aboutUs', 'homeWebLayout']),
    ...mapState("estore", {
      webDesign: (state) => state.webDesign
    })
  }
};
</script>

<style lang="scss" scoped>
  #layout-about {
    font-size: 14px;
    margin-top: 35px;
  }
</style>
